/**
 * 拍单模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取拍单列表
export const auctionList = (params) => {
  return req.get('/order/auction/list', params);
}

// 新增拍单
export const auctionAdd = (params) => {
  return req.post('/order/auction', params);
}

// 拍单修改
export const auctionEdit = (params, flag) => {
  return req.put(`/order/auction?flag=${flag}`, params);
}

// 拍单识别失败
export const auctionFail = (params) => {
  return req.post('/order/auction/recognitionFailed', params);
}

// 拍单作废
export const auctionCancel = (params) => {
  return req.post('/order/auction/cancel', params);
}

// 删除拍单
export const auctionDelete = (auctionId) => {
  return req.delete(`/order/auction/${auctionId}`);
}

// 取消拍单
export const auctionCallOff = (auctionId) => {
  return req.post(`/order/auction/cancel/${auctionId}`);
}

// 获取拍单详情
export const auctionInfo = (auctionId) => {
  return req.get(`/order/auction/${auctionId}`);
}

// 查询拍单划价单状态数量
export const statusNum = (params) => {
  return req.get(`/order/auction/selectStatusNumber`, params);
}